module.exports = __webpack_public_path__ + "img/transfer1.372d3ed0.jpg";